import {createAction, handleActions} from "redux-actions";
import produce from "immer";

const SET_HEADER_LINE = "scroll/SET_HEADER_LINE";
const SET_ID = "scroll/SET_ID";
const MOVE_TO_MENU = "scroll/MOVE_TO_MENU";
const FINISH_MENU_MOVE = "scroll/FINISH_MENU_MOVE";

export const setHeaderLine = createAction(SET_HEADER_LINE, showHeaderLine => showHeaderLine);
export const setId = createAction(SET_ID, id => id);
export const moveToMenu = createAction(MOVE_TO_MENU, id => id);
export const finishMenuMove = createAction(FINISH_MENU_MOVE);



const SET_MENU = "data/SET_MENU";
const SET_SCROLL_TOP = "data/SET_SCROLL_TOP";
export const setMenu = createAction(SET_MENU, menuIndex => menuIndex);
export const setScrollTop = createAction(SET_SCROLL_TOP);


const initialState = {
	menuIndex:0,
	moveToMenu:-1,
	scrollTop:0,

	moveToId:"",
	id:"",
	showHeaderLine:false
};

const ScrollModule = handleActions(
	{
		[SET_HEADER_LINE]: (state, action) => {
			return produce(state, draft => {
				draft.showHeaderLine = action.payload;
			});
		},
		[SET_ID]: (state, action) => {
			return produce(state, draft => {
				draft.id = action.payload;
			});
		},
		[MOVE_TO_MENU]: (state, action) => {
			return produce(state, draft => {
				draft.moveToId = action.payload;
			});
		},
		[FINISH_MENU_MOVE]: (state, action) => {
			return produce(state, draft => {
				draft.moveToId = "";
			});
		},



		[SET_MENU]: (state, action) => {
			return produce(state, draft => {
				draft.menuIndex = action.payload;
			});
		},
		
		
		[SET_SCROLL_TOP]: (state, action) => {
			return produce(state, draft => {
				draft.scrollTop = action.payload;				
			});
		},
	},
	initialState
);

export default ScrollModule;
